export default __webpack_public_path__ + "static/media/blue@2x.9850e794.png";